import {
  TBody,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
import {
  TypographyT40,
  TypographyT52,
} from "Components/Common/Typography/index";
import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { Spacer } from "Components/Common/Spacer/index";

const AdditionalFilesTable = () => {
  return (
    <Fragment>
      <AdditionalFilesTableWrapper>
        <TypographyT52>Additional Files</TypographyT52>
        <Spacer spacing={"2px"} />
        <TableWrapper style={{ height: "fit-content" }}>
          <Table>
            <THead>
              <Tr>
                <Th>File Name</Th>
                <Th> Date</Th>
              </Tr>
            </THead>
            <TBody>
              <Fragment>
                <Tr>
                  <Td>
                    <TypographyT40>File 1</TypographyT40>
                  </Td>
                  <Td>
                    <TypographyT40>26/07/2023,15:00:00</TypographyT40>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <TypographyT40>File 1</TypographyT40>
                  </Td>
                  <Td>
                    <TypographyT40>26/07/2023,15:00:00</TypographyT40>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <TypographyT40>File 1</TypographyT40>
                  </Td>
                  <Td>
                    <TypographyT40>26/07/2023,15:00:00</TypographyT40>
                  </Td>
                </Tr>
              </Fragment>
            </TBody>
          </Table>
        </TableWrapper>
      </AdditionalFilesTableWrapper>
    </Fragment>
  );
};

export default AdditionalFilesTable;

const AdditionalFilesTableWrapper = styled("div")`
  border-radius: 8px;
  background: #fff;
  padding: 8px;
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25));
`;
